import api from '@/services/Api';
import Dienstort from '@/types/Dienstort';
import { successSwal } from '@/helper/swals';
import { ActionContext, Module } from 'vuex';
import { DienstorteState, RootState } from '@/store/types';
import jspm from '@/services/PrintManager';

type Context = ActionContext<DienstorteState, RootState>;

export const dienstorte: Module<DienstorteState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            dienstorte: false,
            printers: false,
        },
        dienstorte: [],
        printers: [],
    },
    actions: {
        loadDienstorte({ commit, rootState }: Context): void {
            commit('setLoadersDienstorte', true);

            api.post('verwaltung/dienstorte/load')
                .then((response) => commit('setDienstorte', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersDienstorte', false));
        },
        updateDienstort({ commit, dispatch }: Context, payload: Dienstort): void {
            commit('setLoadersSave', true);

            api.post('verwaltung/dienstorte/speichern', payload)
                .then(() => {
                    successSwal('Dienstort', 'gespeichert');
                    dispatch('loadDienstorte');
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersSave', false));
        },
        deleteDienstort({ commit, dispatch }: Context, payload: Dienstort): void {
            commit('setLoadersDelete', true);

            api.post('verwaltung/dienstorte/loeschen', payload)
                .then(() => {
                    successSwal('Dienstort', 'gelöscht');
                    dispatch('loadDienstorte');
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDelete', false));
        },
        loadPrinters({ commit, dispatch }: Context): void {
            if (!jspm.printer?.hasConnected()) {
                dispatch('globals/setDialogDruckhinweis', true, { root: true });
                return;
            }

            const { JSPrintManager, WSStatus } = jspm.printer?.manager;

            if (JSPrintManager.websocket_status !== WSStatus.Open) {
                dispatch('globals/setDialogDruckhinweis', true, { root: true });
                return;
            }

            JSPrintManager
                .getPrinters()
                .then((printers: string[]) => commit('setPrinters', printers))
                .catch(console.error);
        },
    },
    mutations: {
        setDienstorte(state: DienstorteState, payload: Dienstort[]): void {
            state.dienstorte = payload.map((data: Dienstort) => new Dienstort(data));
        },
        setDialogsDetail(state: DienstorteState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: DienstorteState, loading: boolean): void {
            state.loaders.save = loading;
        },
        setLoadersDelete(state: DienstorteState, loading: boolean): void {
            state.loaders.delete = loading;
        },
        setLoadersDienstorte(state: DienstorteState, loading: boolean): void {
            state.loaders.dienstorte = loading;
        },
        setLoadersPrinters(state: DienstorteState, loading: boolean): void {
            state.loaders.printers = loading;
        },
        setPrinters(state: DienstorteState, printers: string[]): void {
            state.printers = printers;
        },
    },
};
